export default {
  replaysSessionSampleRate: 0.1,
  tracesSampleRate: 1,
}
